import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal']

  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const modalParam = this.element.dataset.modalParam || 'show_modal';
    const paramMatch = this.element.dataset.paramMatch || 'true';

    if (urlParams.get(modalParam) === paramMatch) {
      $(this.modalTarget).modal('show');
    }
  }
}
